module.exports = __webpack_public_path__ + "static/media/main.138f5cda.svg";